import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";


import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome, faUserFriends, faBriefcase, faHandshake, faChartLine, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faHome, faUserFriends, faBriefcase, faHandshake, faChartLine, faChevronRight)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
